import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export const SettingsTopBar = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <h3 className={styles.title}>{t("common.settings")}</h3>
    </div>
  );
};
